import React, { useEffect, useState } from "react";
import { LineChart as LCIcon, Star, ThumbsUp, Users, ClipboardCheck, RefreshCw } from "lucide-react";
import DashboardShell from "@/layouts/ProviderDashboardLayout";
import api from "@/lib/api";
import { useDocumentTitle } from "@/lib/useDocumentTitle";

export default function ProviderAnalyticsPage() {
  const [data, setData] = useState(null);
  useDocumentTitle("Analytics");
  useEffect(() => { api.get("/provider/analytics").then((r) => setData(r.data)); }, []);
  if (!data) return <DashboardShell><div className="text-[#252A34]/60">Loading…</div></DashboardShell>;
  const c = data.counts || {};
  const r = data.rates || {};
  const cards = [
    { label: "Completed bookings", value: c.bookings_completed, sub: `${c.bookings_total} total`, icon: ClipboardCheck },
    { label: "Completed orders", value: c.orders_completed, sub: `${c.orders_total} total`, icon: ClipboardCheck },
    { label: "Avg rating", value: (c.avg_rating || 0).toFixed(1), sub: `${c.reviews_total} reviews`, icon: Star },
    { label: "Completion rate", value: `${(r.completion_rate * 100).toFixed(1)}%`, icon: ThumbsUp },
    { label: "Cancellation rate", value: `${(r.cancellation_rate * 100).toFixed(1)}%`, icon: RefreshCw },
    { label: "Proposal conversion", value: `${(r.proposal_conversion * 100).toFixed(1)}%`, sub: `${c.proposals_accepted}/${c.proposals_sent}` },
    { label: "Repeat customers", value: c.repeat_customers, icon: Users },
    { label: "Conversations started", value: c.conversations_started, icon: Users },
  ];
  return (
    <DashboardShell>
      <div className="max-w-5xl" data-testid="provider-analytics">
        <div className="mb-6">
          <div className="text-xs font-bold tracking-[0.2em] uppercase text-[#165a71]">Provider · Analytics</div>
          <h1 className="mt-2 font-display text-2xl md:text-3xl font-semibold text-[#071b22]">Your performance at a glance</h1>
          <p className="text-[#252A34]/70 text-sm mt-1">Live-computed from your actual bookings, reviews, and proposals.</p>
        </div>
        <div className="grid gap-4 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4">
          {cards.map((c) => (
            <div key={c.label} className="rounded-2xl border border-slate-200 bg-white p-4" data-testid={`analytics-${c.label.toLowerCase().replace(/[^a-z0-9]/g, "-")}`}>
              <div className="text-xs uppercase tracking-wider text-[#252A34]/60">{c.label}</div>
              <div className="mt-1 font-display text-2xl font-semibold text-[#071b22]">{c.value ?? "—"}</div>
              {c.sub && <div className="text-xs text-[#252A34]/60 mt-1">{c.sub}</div>}
            </div>
          ))}
        </div>
      </div>
    </DashboardShell>
  );
}
